import { useRef } from 'react';
import AppleLogin from 'react-apple-login';
import config from '@/config';
import { useReCaptcha } from '@/providers/recaptcha';
import { Button } from '@scramble/ui';
import IconApple from '@scramble/design-system/icons/social/apple.svg';
import s from './index.module.scss';

export const AppleButton = ({ label, redirectURL, onResponse }) => {
  const { loaded, getCaptchaToken } = useReCaptcha();
  const pendingTokenRef = useRef(null);

  return (
    <AppleLogin
      clientId={config.appleAppId}
      redirectURI={redirectURL}
      usePopup
      callback={response => onResponse(response, pendingTokenRef.current)}
      scope="email name"
      responseMode="query"
      render={renderProps => (
        <Button
          theme="neutral"
          appearance="tonal"
          className={s.button}
          onClick={async () => {
            if (loaded) {
              const token = await getCaptchaToken();
              pendingTokenRef.current = token;
              token && renderProps.onClick();
            }
          }}
        >
          <img src={IconApple} width={24} height={24} alt="Apple" />
          <span className="f-body-md f-500">{label}</span>
        </Button>
      )}
    />
  );
};
